export enum UploadStatus {
  NO = 'NO',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
}